module.exports = __webpack_public_path__ + "static/media/cloud-a-v3@2x.13b754fe.png";